import React, { useState, useEffect } from "react";
import { Table } from "antd";
import Api from "../../../../../services/ServiceApi";
import JobTypeModal from "./job_type_modal/JobTypeModal";
import Cookies from "js-cookie";
import moment from "moment";
import { VList } from "virtuallist-antd";

// import LockingDocumentTable from "../Locking_document_modal/LockingDocumentModal";
// const JobLockingTable = ({ tabStatus, setLockedData , jobLockingData}) => {
  const JobLockingTable = ({setLockedData , jobLockingData}) => {

  // const [isVisibleLockingDocument, setVisibleLockingDocument] = useState(false);

  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [modalData, setModalData] = useState([]);
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD/MM/YYYY HH:mm"];


  useEffect(() => {
    console.log("reach here or not");
    setFilteredData(jobLockingData);
    setLockedData(selectedRows);
  }, [selectedRows]);

  function del_locking(data){
    console.log('del_locking data', data);
    Api.post("BusLockingDelete", {   
      "bus_locking_id" : data.bus_locking_id
      ,"bus_id" : data.bus_id
      ,"create_by" : Cookies.get("userId")
    })
      .then((res) => {
        console.log('del_locking res',res);  
        alert('delete locking success')
        window.location.reload(false);
        // setBookingData(res.data.data.bus_booking_list)
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function complete_locking(data){
    console.log('complete_locking data', data);
 
    Api.post("BusLockingComplete", {   
      "bus_locking_id" : data.bus_locking_id
      ,"bus_id" : data.bus_id
      ,"create_by" : Cookies.get("userId")
    })
      .then((res) => {
        console.log('del_locking res',res);  
        alert('update complete')
        window.location.reload(false);
      })
      .catch((e) => {
        console.log(e);
      });

  }
  
  function checkStatusForStyle(status) {
    switch (status) {
      case "Wait Assign":
        return <div className="ref-status-wait-assign">{status}</div>;
      case "Approved":
        return <div className="ref-status-approved">{status}</div>;
    }
  }

  const LoadDataTableModal = async (item) => {
   await  Api.post("get_query_group_list", {
      "company_id": Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id"),
      "project_id": Cookies.get("project_id"),
      "query_id": "29", 
      "query_module": "bus",
      // "param_text": "@job_id_list:$'18194,18196'",
      "param_text": "@job_id_list:$'"+item+"'",
      "where_cond": ""
    }).then((res) => { 

      console.log(res.data.data.list_bus_locking_detail_list);
      if(res.data.result.code.toLowerCase() == "p"){
        setModalData(res.data.data.list_bus_locking_detail_list)
      }
    });
  }


  const columns = [
    // Bus
    {
      title: "Locking Reference",
      children: [
        {
          title: "Locked ID",
          dataIndex: "locking_code",
          width: 120,
          key: "locking_code",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.locking_code !== undefined && b.locking_code !== undefined) &&  (a.locking_code !== null && b.locking_code !== null) ){ 
                    return   a.locking_code.localeCompare(b.locking_code)
            }
         }

        },
        {
          title: "Customer",
          dataIndex: "customer",
          width: 120,
          key: "customer",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.customer !== undefined && b.customer !== undefined) &&  (a.customer !== null && b.customer !== null) ){ 
                    return   a.customer.localeCompare(b.customer)
            }
         }
        },
        {
          title: "Project",
          dataIndex: "project_name",
          width: 120,
          key: "project_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.project_name !== undefined && b.project_name !== undefined) &&  (a.project_name !== null && b.project_name !== null) ){ 
                    return   a.project_name.localeCompare(b.project_name)
            }
         }
        },
        {
          title: "Advertise",
          dataIndex: "advertise_list_id",
          width: 120,
          key: "advertise_list_id",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.advertise_list_id !== undefined && b.advertise_list_id !== undefined) &&  (a.advertise_list_id !== null && b.advertise_list_id !== null) ){ 
                    return   a.advertise_list_id.localeCompare(b.advertise_list_id)
            }
         }
        },
        {
          title: "Area Name",
          dataIndex: "area_name",
          width: 120,
          key: "area_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.area_name !== undefined && b.area_name !== undefined) &&  (a.area_name !== null && b.area_name !== null) ){ 
                    return   a.area_name.localeCompare(b.area_name)
            }
         }
        },
        {
          title: "Division Name",
          dataIndex: "division_name",
          width: 120,
          key: "division_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.division_name !== undefined && b.division_name !== undefined) &&  (a.division_name !== null && b.division_name !== null) ){ 
                    return   a.division_name.localeCompare(b.division_name)
            }
         }
        },
        {
          title: "Garage Name",
          dataIndex: "garage_name",
          width: 120,
          key: "garage_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.garage_name !== undefined && b.garage_name !== undefined) &&  (a.garage_name !== null && b.garage_name !== null) ){ 
                    return   a.garage_name.localeCompare(b.garage_name)
            }
         }
        },
        {
          title: "Bus Line Name",
          dataIndex: "bus_line_name",
          width: 120,
          key: "bus_line_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.bus_line_name !== undefined && b.bus_line_name !== undefined) &&  (a.bus_line_name !== null && b.bus_line_name !== null) ){ 
                    return   a.bus_line_name.localeCompare(b.bus_line_name)
            }
         }
        },
        {
          title: "Bus No",
          dataIndex: "bus_no",
          width: 120,
          key: "bus_no",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.bus_no !== undefined && b.bus_no !== undefined) &&  (a.bus_no !== null && b.bus_no !== null) ){ 
                    return   a.bus_no.localeCompare(b.bus_no)
            }
         }
        },
        {
          title: "Plate No.",
          dataIndex: "license_plate",
          width: 120,
          key: "license_plate",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.license_plate !== undefined && b.license_plate !== undefined) &&  (a.license_plate !== null && b.license_plate !== null) ){ 
                    return   a.license_plate.localeCompare(b.license_plate)
            }
         }
        },
        {
          title: "Locked Type",
          dataIndex: "booking_lock_type",
          width: 120,
          key: "booking_lock_type",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.booking_lock_type !== undefined && b.booking_lock_type !== undefined) &&  (a.booking_lock_type !== null && b.booking_lock_type !== null) ){ 
                    return   a.booking_lock_type.localeCompare(b.booking_lock_type)
            }
         }
          // dataIndex: "lockedType",
          // key: "lockedType",
        },
        {
          title: "Remark",
          dataIndex: "remark",
          width: 120,
          key: "remark",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.remark !== undefined && b.remark !== undefined) &&  (a.remark !== null && b.remark !== null) ){ 
                    return   a.remark.localeCompare(b.remark)
            }
         }
        },
        {
          title: "Previous Internal Ad",
          dataIndex: "prev_internal_ad_name",
          width: 200,
          key: "prev_internal_ad_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.prev_internal_ad_name !== undefined && b.prev_internal_ad_name !== undefined) &&  (a.prev_internal_ad_name !== null && b.prev_internal_ad_name !== null) ){ 
                    return   a.prev_internal_ad_name.localeCompare(b.prev_internal_ad_name)
            }
         }
        },
        {
          title: "Previous External Ad",
          dataIndex: "prev_external_ad_name",
          width: 200,
          key: "prev_external_ad_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.prev_external_ad_name !== undefined && b.prev_external_ad_name !== undefined) &&  (a.prev_external_ad_name !== null && b.prev_external_ad_name !== null) ){ 
                    return   a.prev_external_ad_name.localeCompare(b.prev_external_ad_name)
            }
         }
        },
        {
          title: "Previous Uninstall",
          dataIndex: "prev_uninstall_flag",
          width: 200,
          key: "prev_uninstall_flag",
          render: (item) => {
            {
              return item === null || item === 0 || item === undefined
                ?  <span className="badge badge-pill badge-primary font-thai-b font14">
                      Not Uninstalled
                   </span>
                : <span className="badge badge-pill badge-success font-thai-b font14">
                      Uninstalled
                  </span>;
            }
          },
          sorter: (a, b) => 
          (a.prev_uninstall_flag === null || a.prev_uninstall_flag  === undefined ? 0 : a.prev_uninstall_flag) -  
          (b.prev_uninstall_flag === null || b.prev_uninstall_flag  === undefined ? 0 : b.prev_uninstall_flag)
        //     {
        //     if( (a.prev_uninstall_flag !== undefined && b.prev_uninstall_flag !== undefined) &&  (a.prev_uninstall_flag !== null && b.prev_uninstall_flag !== null) ){ 
        //             return   a.prev_uninstall_flag - b.prev_uninstall_flag
        //     }
        //  }

        },
        {
          title: "Remark",
          dataIndex: "remark",
          width: 120,
          key: "remark",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          )
          ,
          sorter: (a, b) => {
            if( (a.remark !== undefined && b.remark !== undefined) &&  (a.remark !== null && b.remark !== null) ){ 
                    return   a.remark.localeCompare(b.remark)
            }
         }
        },


        {
          title: "Internal Advertise Name",
          dataIndex: "internal_advertise_name",
          width: 200,
          key: "internal_advertise_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          ),
          sorter: (a, b) => {
            if( (a.internal_advertise_name !== undefined && b.internal_advertise_name !== undefined) &&  (a.internal_advertise_name !== null && b.internal_advertise_name !== null) ){ 
                    return   a.internal_advertise_name.localeCompare(b.internal_advertise_name)
            }
         }
        },
        
        {
          title: "External Advertise Name",
          dataIndex: "external_advertise_name",
          width: 200,
          key: "external_advertise_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          ),
          sorter: (a, b) => {
            if( (a.external_advertise_name !== undefined && b.external_advertise_name !== undefined) &&  (a.external_advertise_name !== null && b.external_advertise_name !== null) ){ 
                    return   a.external_advertise_name.localeCompare(b.external_advertise_name)
            }
         }
        },

        
        {
          title: "Action",
          dataIndex: "",
          width: 120,
          key: "",
          render: (record, data) => 
              // isAction ? (
                parseInt(localStorage.getItem("permission"))  === 1  ?
                <span>
                  <button onClick={() => {complete_locking(data)}}>
                <img src={Api.absoluteUrl("/icon/correct.svg")} />
              </button>
              
                <button onClick={() => {del_locking(data)}}>
                <img src={Api.absoluteUrl("/icon/del.svg")} />
              </button>
              </span>      
                  : "-"
            // ) : null,
          
            
        },
      ],
    },
    // printing
    {
      title: "Printing",
      children: [
        {
          title: "Printing Ref.",
          dataIndex: "curr_print_job_no",
          key: "curr_print_job_no",
          width: 200,
          // dataIndex: "printingRef",
          // key: "printingRef",
          render: (item, object) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
            //   // if (jobs[i].job_type === "1") {
                return (
                  item ?
                  <button
                    className="c-blue text-underline"
                    onClick={() => {
                      console.log('jobs',item);
                      setIsModalVisible(true); 
                      LoadDataTableModal(object.job_lock_printing);
                      setTitle("Printing");
                    }}
                  >
                    {item}
                  </button>
                  :
                  "-"
                );
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_print_job_no !== undefined && b.curr_print_job_no !== undefined) &&  (a.curr_print_job_no !== null && b.curr_print_job_no !== null) ){ 
                    return   a.curr_print_job_no.localeCompare(b.curr_print_job_no)
            }
         }
        },
        {
          title: "Start Date",
          dataIndex: "curr_print_job_date_st",
          width: 200,
          key: "curr_print_job_date_st",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                <div>{item ? moment(item).format(dateFormatList[2]) : "-"}</div>
              )
              // if (jobs[i].job_type === "3") {
              //   return checkStatusForStyle(jobs[i].job_status);
              // }
            },
          sorter: (a, b) => {
            if( (a.curr_print_job_date_st !== undefined && b.curr_print_job_date_st !== undefined) &&  (a.curr_print_job_date_st !== null && b.curr_print_job_date_st !== null) ){ 
                    return   a.curr_print_job_date_st.localeCompare(b.curr_print_job_date_st)
            }
         }
        },
        {
          title: "Finish Date",
          dataIndex: "curr_print_job_date_finish",
          width: 200,
          key: "curr_print_job_date_finish",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                <div>{item ? moment(item).format(dateFormatList[2]) : "-"}</div>
              )
            //   // if (jobs[i].job_type === "3") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_print_job_date_finish !== undefined && b.curr_print_job_date_finish !== undefined) &&  (a.curr_print_job_date_finish !== null && b.curr_print_job_date_finish !== null) ){ 
                    return   a.curr_print_job_date_finish.localeCompare(b.curr_print_job_date_finish)
            }
         }
        },
        {
          title: "Status",
          dataIndex: "curr_print_job_status",
          width: 200,
          key: "curr_print_job_status",
          // dataIndex: "printingRef",
          // key: "printingStatus",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                item ?<div className="ref-status-wait-assign">{item}</div> : "-"
              )
            //   // return jobs[i].job_status
            //   // if (jobs[i].job_type === "1") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_print_job_status !== undefined && b.curr_print_job_status !== undefined) &&  (a.curr_print_job_status !== null && b.curr_print_job_status !== null) ){ 
                    return   a.curr_print_job_status.localeCompare(b.curr_print_job_status)
            }
         }
        },
      ],
    },
    // Install
    {
      title: "Install",
      children: [
        {
          title: "Install - Bus Ref.",
          dataIndex: "curr_install_job_no",
          width: 140,
          key: "curr_install_job_no",
          render: (item, object) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
            //   // if (jobs[i].job_type === "2") {
                return (
                  item ?
                  <button
                    className="c-blue text-underline"
                    onClick={() => {
                      console.log('jobs',item);
                      setIsModalVisible(true);
                      LoadDataTableModal(object.job_install);
                      setTitle("Install - Bus Ref.");
                    }}
                  >
                    {item}
                  </button>
                  : "-"
                );
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_install_job_no !== undefined && b.curr_install_job_no !== undefined) &&  (a.curr_install_job_no !== null && b.curr_install_job_no !== null) ){ 
                    return   a.curr_install_job_no.localeCompare(b.curr_install_job_no)
            }
         }
        },
        {
          title: "Start Date",
          dataIndex: "curr_install_job_date_st",
          width: 120,
          key: "curr_install_job_date_st",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                <div>{item ? moment(item).format(dateFormatList[2]) : "-"}</div>
              )
            //   // if (jobs[i].job_type === "3") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_install_job_date_st !== undefined && b.curr_install_job_date_st !== undefined) &&  (a.curr_install_job_date_st !== null && b.curr_install_job_date_st !== null) ){ 
                    return   a.curr_install_job_date_st.localeCompare(b.curr_install_job_date_st)
            }
         }
        },
        {
          title: "Finish Date",
          dataIndex: "curr_install_job_date_finish",
          width: 120,
          key: "curr_install_job_date_finish",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                <div>{item ? moment(item).format(dateFormatList[2]) : "-"}</div>
              )
            //   // if (jobs[i].job_type === "3") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_install_job_date_finish !== undefined && b.curr_install_job_date_finish !== undefined) &&  (a.curr_install_job_date_finish !== null && b.curr_install_job_date_finish !== null) ){ 
                    return   a.curr_install_job_date_finish.localeCompare(b.curr_install_job_date_finish)
            }
         }
        },
        {
          title: "Status",
          dataIndex: "curr_install_job_status",
          width: 200,
          key: "curr_install_job_status",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                item ?<div className="ref-status-wait-assign">{item}</div> : "-"
              )
            //   // if (jobs[i].job_type === "2") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_install_job_status !== undefined && b.curr_install_job_status !== undefined) &&  (a.curr_install_job_status !== null && b.curr_install_job_status !== null) ){ 
                    return   a.curr_install_job_status.localeCompare(b.curr_install_job_status)
            }
         }
        },
      ],
    },
    // ใบอนุญาต
    {
      title: "ใบอนุญาต",
      children: [
        {
          title: "ขอใบอนุญาต Ref.",
          dataIndex: "curr_permit_job_no",
          width: 150,
          key: "curr_permit_job_no",
          render: (item, object) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
            //   // if (jobs[i].job_type === "3") {
                return (
                  item ?
                  <button
                    className="c-blue text-underline"
                    onClick={() => {
                      console.log('jobs',item);
                      setIsModalVisible(true);
                      LoadDataTableModal(object.job_permit);
                      setTitle("Permission");
                    }}
                  >
                    {item}
                  </button>
                  : "-"
                );
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_permit_job_no !== undefined && b.curr_permit_job_no !== undefined) &&  (a.curr_permit_job_no !== null && b.curr_permit_job_no !== null) ){ 
                    return   a.curr_permit_job_no.localeCompare(b.curr_permit_job_no)
            }
         }
        },
        {
          title: "Start Date",
          dataIndex: "curr_permit_job_date_st",
          width: 120,
          key: "curr_permit_job_date_st",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                <div>{item  ? moment(item).format(dateFormatList[2]): "-"}</div>
              )
            //   // if (jobs[i].job_type === "3") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_permit_job_date_st !== undefined && b.curr_permit_job_date_st !== undefined) &&  (a.curr_permit_job_date_st !== null && b.curr_permit_job_date_st !== null) ){ 
                    return   a.curr_permit_job_date_st.localeCompare(b.curr_permit_job_date_st)
            }
         }
        },
        {
          title: "End Date",
          dataIndex: "curr_permit_job_date_finish",
          width: 120,
          key: "curr_permit_job_date_finish",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                <div>{item  ? moment(item).format(dateFormatList[2]): "-"}</div>
              )
            //   // if (jobs[i].job_type === "3") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_permit_job_date_finish !== undefined && b.curr_permit_job_date_finish !== undefined) &&  (a.curr_permit_job_date_finish !== null && b.curr_permit_job_date_finish !== null) ){ 
                    return   a.curr_permit_job_date_finish.localeCompare(b.curr_permit_job_date_finish)
            }
         }
        },
        {
          title: "Status",
          dataIndex: "curr_permit_job_status",          
          width: 200,
          key: "curr_permit_job_status",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                item ?<div className="ref-status-wait-assign">{item}</div> : "-"
              )
              // if (jobs[i].job_type === "3") {
              //   return checkStatusForStyle(jobs[i].job_status);
              // }
            // }
          },
        },
        {
          title: "ติดตั้งใบอนุญาต Ref.",
          dataIndex: "curr_permit_inst_job_no",
          width: 200,
          key: "curr_permit_inst_job_no",
          // dataIndex: "installedPermissionRef",
          // key: "installedPermissionRef",
          render: (item, object) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
            //   if (jobs[i].job_type === "4") {
                return (
                  item ?
                  <button
                    className="c-blue text-underline"
                    onClick={() => {
                      console.log('jobs',item);
                      setIsModalVisible(true);
                      LoadDataTableModal(object.job_permit_install);
                      setTitle("Installed Permission");
                    }}
                  >
                    {item}
                  </button>
                  : "-"
                );
            //   }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_permit_inst_job_no !== undefined && b.curr_permit_inst_job_no !== undefined) &&  (a.curr_permit_inst_job_no !== null && b.curr_permit_inst_job_no !== null) ){ 
                    return   a.curr_permit_inst_job_no.localeCompare(b.curr_permit_inst_job_no)
            }
         }
        },
        {
          title: "Status",
          dataIndex: "curr_permit_inst_job_status",
          width: 200,
          key: "curr_permit_inst_job_status",
          render: (item) => {
            // for (let i = 0; i < (jobs === null ? [] : jobs).length; i++) {
              return (
                item ?<div className="ref-status-wait-assign">{item}</div> : "-"
              )
            //   // if (jobs[i].job_type === "4") {
            //   //   return checkStatusForStyle(jobs[i].job_status);
            //   // }
            // }
          },
          sorter: (a, b) => {
            if( (a.curr_permit_inst_job_status !== undefined && b.curr_permit_inst_job_status !== undefined) &&  (a.curr_permit_inst_job_status !== null && b.curr_permit_inst_job_status !== null) ){ 
                    return   a.curr_permit_inst_job_status.localeCompare(b.curr_permit_inst_job_status)
            }
         }
        },
      ],
    },
    {
      title: "Uninstall",
      children: [
        {
          title: "Uninstall - Bus Ref.",
          dataIndex: "curr_uninst_job_no",
          width: 200,
          key: "curr_uninst_job_no",
          render: (item, object) => {
              return (
                item === null ? "-" :
                <button
                className="c-blue text-underline"
                onClick={() => {
                  console.log('jobs',item);
                  // console.log('obj',object);

                  setIsModalVisible(true);
                  LoadDataTableModal(object.job_uninstall);
                  setTitle("Printing");
                }}
              >
                {item}
              </button>
              )
          },
          sorter: (a, b) => {
            if( (a.curr_uninst_job_no !== undefined && b.curr_uninst_job_no !== undefined) &&  (a.curr_uninst_job_no !== null && b.curr_uninst_job_no !== null) ){ 
                    return   a.curr_uninst_job_no.localeCompare(b.curr_uninst_job_no)
            }
         }
        },
        {
          title: "Start Date",
          dataIndex: "curr_uninst_job_date_st",
          width: 120,
          key: "curr_uninst_job_date_st",
          render: (item) => {
            return (
              item === null ? "-" :
              <div>{item ? moment(item).format(dateFormatList[2]) : "-"}</div>
              )
          },
          sorter: (a, b) => {
            if( (a.curr_uninst_job_date_st !== undefined && b.curr_uninst_job_date_st !== undefined) &&  (a.curr_uninst_job_date_st !== null && b.curr_uninst_job_date_st !== null) ){ 
                    return   a.curr_uninst_job_date_st.localeCompare(b.curr_uninst_job_date_st)
            }
         }
        },
        {
          title: "End Date",
          dataIndex: "curr_uninst_job_date_finish",
          width: 120,
          key: "curr_uninst_job_date_finish",
          render: (item) => {
            return (
              item === null ? "-" :
              <div>{item ? moment(item).format(dateFormatList[2]) : "-"}</div>
              )
          },
          sorter: (a, b) => {
            if( (a.curr_uninst_job_date_finish !== undefined && b.curr_uninst_job_date_finish !== undefined) &&  (a.curr_uninst_job_date_finish !== null && b.curr_uninst_job_date_finish !== null) ){ 
                    return   a.curr_uninst_job_date_finish.localeCompare(b.curr_uninst_job_date_finish)
            }
         }
        },
        {
          title: "Status",
          dataIndex: "curr_uninst_job_status",
          width: 200,
          key: "curr_uninst_job_status",
          render: (item) => {
            return (
              item === null ? "-" :
              <div className="ref-status-wait-assign">{item}</div>
            )
          },
          sorter: (a, b) => {
            if( (a.curr_uninst_job_status !== undefined && b.curr_uninst_job_status !== undefined) &&  (a.curr_uninst_job_status !== null && b.curr_uninst_job_status !== null) ){ 
                    return   a.curr_uninst_job_status.localeCompare(b.curr_uninst_job_status)
            }
         }
        },
       
      ],
    },

    {
      title: "",
      children: [
        {
          title: "Prev Internal Ad Name",
          dataIndex: "prev_internal_ad_name",
          width: 200,
          key: "prev_internal_ad_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          ),
          sorter: (a, b) => {
            if( (a.prev_internal_ad_name !== undefined && b.prev_internal_ad_name !== undefined) &&  (a.prev_internal_ad_name !== null && b.prev_internal_ad_name !== null) ){ 
                    return   a.prev_internal_ad_name.localeCompare(b.prev_internal_ad_name)
            }
         }
        },
        {
          title: "Prev External Ad Name",
          dataIndex: "prev_external_ad_name",
          width: 200,
          key: "prev_external_ad_name",
          render: (item) => ( 
            item === null || item === "" ? "-" : item
          ),
          sorter: (a, b) => {
            if( (a.prev_external_ad_name !== undefined && b.prev_external_ad_name !== undefined) &&  (a.prev_external_ad_name !== null && b.prev_external_ad_name !== null) ){ 
                    return   a.prev_external_ad_name.localeCompare(b.prev_external_ad_name)
            }
         }
        },
      ],
    },
  ];

  // const finalMockData = [
  //   {
  //     area_name: "3",
  //     booking_code: "B_A000001",
  //     bus_booking_id: 30,
  //     bus_group_id: 2,
  //     bus_group_name: "สัมปทาน",
  //     bus_id: 1,
  //     bus_line_id: 1,
  //     bus_line_name: "102",
  //     bus_locking_id: 1,
  //     bus_no: "70380",
  //     bus_status: true,
  //     bus_type_id: 1,
  //     bus_type_name: "บีแอลเค",
  //     customer: "Mikku V1.1",
  //     division_id: 3,
  //     division_name: "2",
  //     fw: false,
  //     garage_id: 14,
  //     garage_name: "ฟาร์มจระเข้",
  //     has_bus_patent: false,
  //     has_contract: false,
  //     hg: false,
  //     hw: false,
  //     ib: null,
  //     jobs: [],
  //     lcd: false,
  //     led: false,
  //     license_plate: "16-2376",
  //     locking_code: "L_A000001",
  //     media_id: "Bus 2774",
  //     model_id: 1,
  //     model_name: "BLK01",
  //     qw: false,
  //     reflective_film: false,
  //     remark: "remark2",
  //     special: false,
  //     sub_status: "locked",
  //     three_d: false,
  //     two_d: false,
  //     printingRef: [
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000001",
  //         job_type: "1",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000002",
  //         job_type: "1",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //     ],
  //     printingStatus: "Wait Assign",
  //     installedBusRef: [
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000002",
  //         job_type: "2",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000003",
  //         job_type: "2",
  //         job_id: "153",
  //         job_no: "20201201000228",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-03 10:00:00",
  //       },
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000004",
  //         job_type: "2",
  //         job_id: "154",
  //         job_no: "20201201000229",
  //         job_status: "Approved",
  //         create_date: "2020-12-05 10:00:00",
  //       },
  //     ],
  //     installedStatus: "Approved",
  //     permissionRef: [
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000001",
  //         job_type: "3",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000002",
  //         job_type: "3",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //     ],
  //     permissionStatus: "Approved",
  //     installedPermissionRef: [
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000001",
  //         job_type: "4",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000002",
  //         job_type: "4",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //     ],
  //     installedPermissionStatus: "Wait Assign",
  //     uninstalledRef: [
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000001",
  //         job_type: "5",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //       {
  //         bus_locking_id: "1",
  //         locking_code: "L_A000002",
  //         job_type: "5",
  //         job_id: "152",
  //         job_no: "20201201000227",
  //         job_status: "Wait Assign",
  //         create_date: "2020-12-01 10:00:00",
  //       },
  //     ],
  //     uninstalledStatus: "Approved",
  //   },
  // ];

  // const onSelectChange = (tempRowKeys, tempRows) => {
  //   // console.log(tempRowKeys);
  //   console.log(tempRows);
  //   setSelectedRowKeys(tempRowKeys);
  //   setSelectedRows(tempRows);
  //   // กรณีเปลี่ยน tab และselect booked bus เพิ่ม
  //   // setBookedData(tempRows);
  //   // console.log(selectedRowKeys);
  //   console.log(selectedRows);
  // };

  const rowSelection = {
    // selectedRowKeys,
    // onChange:   
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelectedRows(selectedRows)
    },
  };


  // 1 คือ printing ,2 คือ  install , 3 คือ ขอใบอนุญาติ , 4 คือ ติดตั้งใบอนุญาติ , 5 คือ uninstall
  return (
    <React.Fragment>
      {/* {console.log(jobLockingData)} */}
      <Table
        rowKey="row_key"
        // rowKey="bus_locking_id"
        columns={columns}
        // dataSource={finalMockData}
        dataSource={jobLockingData}
        rowSelection={{...rowSelection}}
        pagination={false}   
        scroll={{ x: 3000 , y : 500}}
        components={VList? VList({
          height: "500",
          width: "3000",
          vid:"second"
        }): null}
      />
      {/* {isVisibleLockingDocument ? (
        <LockingDocumentTable handleVisible={setVisibleLockingDocument} />
      ) : null} */}
      <JobTypeModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        dataSource={modalData}
        title={title}
      />
    </React.Fragment>
  );
};

export default JobLockingTable;
